// extracted by mini-css-extract-plugin
export default {"productDescription":"Qba-z","featuredDescription":"Rba-z","description":"Sba-z","more":"Tba-z","descriptionSku":"Uba-z"};